import Vue from "vue";

// Opções de execução exclusivas de administradores (testes de latência no cluster).
//   override: máquinas escolhidas para a próxima execução ({ nodes: [...], tasksPerNode, threads }) ou null
//   overLimit: processos × threads pedidos não cabem em alguma máquina escolhida (o Slurm recusaria)
//   benchmark: comparativo da mesma simulação em várias configurações
// O servidor confere o login de administrador; usuários comuns nunca enviam estes campos.
export const adminRun = Vue.observable({
  mode: "auto",
  configs: [],
  override: null,
  overLimit: false,
  benchmark: {
    open: false, running: false, comparing: false, kind: "2d", title: "", results: [], current: -1, error: "",
    startedAt: ""
  }
});

// Campo `cluster` aceito pelas APIs do Meep e do NGSolve
export function clusterField(override) {
  if (!override || !Array.isArray(override.nodes) || !override.nodes.length) return null;
  return {
    nodes: override.nodes,
    ...(override.tasksPerNode ? { tasksPerNode: override.tasksPerNode, tasks_per_node: override.tasksPerNode } : {}),
    ...(override.threads ? { threads: override.threads } : {})
  };
}
